const units = [
  "%",
  "fL",
  "g/dl",
  "g/L",
  "IU/L",
  "IU/mL",
  "mcg/dL",
  "mg/dl",
  "mg/g",
  "mg/L",
  "mEq/L",
  "mIU/L",
  "mIU/mL",
  "mil/mL",
  "mL/min/1.73m²",
  "mm/Hr",
  "mmol/l",
  "ng/dL",
  "ng/ml",
  "nkat/L",
  "nmol/L",
  "pg",
  "pg/mL",
  "pmol/L",
  "U/L",
  "U/mL",
  "UIU/ML",
  "umol/L",
  "Ratio",
];

export default units;
